<template>
  <div v-if="params" class="range-filter-wrap">
    <div class="range-filter-values">
            <span :class="[`range-${name}-value-first` ,{'and-more': andMoreFlag},'range-filter-item']">
                <input class="range-filter-value" :id="`range-${name}-value-first`" :type="typeInput"/> {{ unit }}
            </span>

      <span class="range-filter-name">{{ title }}</span>

      <span :class="[`range-${name}-value-second`, {'and-more': andMoreFlag},'range-filter-item']">
                <input class="range-filter-value blue" :id="`range-${name}-value-second`" :type="typeInput"/>{{ unit }}
            </span>
    </div>

    <div class="range-filter" :id="`range-${name}`"></div> <!-- style="display: block" -->
  </div>
</template>

<script>
// import fnc from "./func";
import Vue from "vue";
import EventBus from '@/eventBus'

export default {
  props: {
    title: String,
    name: String,
    filters: Object,
    params: {
      type: [Object, Array],
      default: () => []
    },
    dots: {
      type: Boolean,
      default: true
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    elem: null,
    // watchFilter: this.filters[this.name],
    min: 0,
    max: 20000000,
    // step: 100000,
    andMoreFlag: false,
    mobileDevice: false
  }),
  methods: {
    diff(o1, o2) {
      let diff = Object.keys(o2).reduce((diff, key) => {
        if (o1[key] === o2[key]) return diff
        return {
          ...diff,
          [key]: o2[key]
        }
      }, {})

      return diff;
    },
    init() {
      let th = this;
      let elem = document.getElementById("range-" + th.name);
      this.elem = elem;
      if (elem && this.params) {
        let rangeValues = [
          document.getElementById("range-" + th.name + "-value-first"),
          document.getElementById("range-" + th.name + "-value-second")
        ];

        // eslint-disable-next-line

        noUiSlider.create(elem, {
          start: th.params.start,
          margin: th.params.step ? th.params.step : th.step,
          connect: true,
          step: th.params.step ? th.params.step : th.step,
          range: {
            min: th.params.min,
            max: th.params.max
          },
          format: {
            to: (value) => Number(value).toFixed(),
            from: (value) => Number(value).toFixed()
          }
        });

        //array left and right price handle slider    ([min , max])
        //left or right selected handle slider        (0 or 1)
        elem.noUiSlider.on("update", (values, handle) => {
          values[handle] = parseInt(values[handle]);

          const value = th.dots ? values[handle].format() : values[handle];
          const moreFlag = ['ekinn', 'verd'];
          const max = th.params.max;

          if(th.name == 'argerd'){
            values[0] >  th.params.min ? this.andMoreFlag = false : this.andMoreFlag = true;
          }

          if (moreFlag.indexOf(th.name) >= 0) {
            values[1] < max ? this.andMoreFlag = false : this.andMoreFlag = true;
          }

          if (this.mobileDevice) {
            rangeValues[handle].value = values[handle];
          } else {
            rangeValues[handle].value = value;
          }
        });

        //array left and right price handle slider    ([min , max])
        //left or right selected handle slider        (0 or 1)
        elem.noUiSlider.on("change", (values, handle) => {
          // console.log("change");
          values[handle] = parseInt(values[handle]);

          const value = th.dots ? values[handle].format() : values[handle]

          // input value in span price
          if (this.mobileDevice) {
            rangeValues[handle].value = values[handle];
          } else {
            rangeValues[handle].value = value;
          }

          const valueLeft = parseInt(values[0]);
          const valueRight = parseInt(values[1]);

          // Right handle have max value and in filter no selected condition
          if (valueLeft === th.min && valueRight >= th.max && th.$store.state.selected_filters_count <= 1) {

            Vue.set(th.filters, th.name, []);
          } else if (valueLeft > th.min && valueRight >= th.max && th.$store.state.selected_filters_count > 1) {

            // Right handle have max value and in filter selected more than 1 condition
            Vue.set(th.filters[th.name], 0, valueLeft);
            Vue.set(th.filters[th.name], 1, th.max);
          } else if (valueRight < th.max) {

            // Right handle have value less than max value
            Vue.set(th.filters[th.name], handle, parseInt(values[handle]));
          } else {

            Vue.set(th.filters[th.name], 0, valueLeft);
            Vue.set(th.filters[th.name], 1, th.max);
          }
        });

        // Reset Slider
        EventBus.$on('resetAllFilters', () => {
          // Left handle
          setRangeValues(0, th.params.min.format())

          // Right handle
          setRangeValues(1, th.params.max.format())
        });

        rangeValues[0].addEventListener("change", function (e) {
          setInputValue(e, 0);
        });
        rangeValues[1].addEventListener("change", function (e) {
          setInputValue(e, 1);
        });
        rangeValues[0].addEventListener("keypress", function (e) {
          var key = e.which || e.keyCode;

          if (key == 13) {
            setInputValue(e, 0);
          }
        });

        rangeValues[1].addEventListener("keypress", function (e) {
          const key = e.which || e.keyCode;
          if (key == 13) {
            setInputValue(e, 1);
          }
        });

        function setInputValue(e, item) {
          e.preventDefault();
          const value = parseInt(e.target.value.split(".").join(""));
          Vue.set(th.filters[th.name], item, value);
        }

        // eslint-disable-next-line
        function setRangeValues(handle, value) {
          let intValue = null;

          typeof value != 'number' &&
          th.dots ? intValue = parseInt(value.split(".").join("")) : intValue = value

          if (handle === 0) {
            Vue.set(th.filters[th.name], 0, intValue);
            elem.noUiSlider.set([intValue, null]);
          } else {
            Vue.set(th.filters[th.name], 1, intValue);
            elem.noUiSlider.set([null, intValue]);
          }
        }
      }
    }
  },
  mounted() {
    // if (window.innerWidth <= 768) {
    //   this.mobileDevice = true
    // }
    this.init()
  },
  computed: {
    typeInput() {
      return this.mobileDevice && this.filters[this.name] ? 'number' : 'text'
    }
  },
  watch: {
    'filters': {
      handler() {
        let val = this.filters[this.name];

        const sliderFilters = ['affinity', 'towing_capacity', 'tire_size', 'rim_size', 'cylinders', 'engine', 'battery_capacity', 'co2', 'horse_power']

        if(sliderFilters.includes(this.name) && val.length == 0){
          val = [this.params.min,this.params.max];
        }


        const elem = this.elem;

        let cur_verd = elem.noUiSlider.get();

        let PriceLeft = parseInt(val[0]);
        let PriceRight = parseInt(val[1]);

        if (PriceLeft === 0) {
          elem.noUiSlider.set([0, null]);
        }
        if (PriceLeft && PriceLeft != cur_verd[0]) {
          elem.noUiSlider.set([PriceLeft, null]);
        }
        if (PriceRight && PriceRight != cur_verd[1]) {
          elem.noUiSlider.set([null, PriceRight]);
        }

      },
      deep: true,
    },
    /*
    'filters.argerd': function () {
      const elem = this.elem;
      const val = this.filters[this.name];


      let cur_verd = elem.noUiSlider.get();
      let PriceLeft = parseInt(val[0]);
      let PriceRight = parseInt(val[1]);

      if (PriceLeft === 0) {
        elem.noUiSlider.set([0, null]);
      }
      if (PriceLeft && PriceLeft != cur_verd[0]) {
        elem.noUiSlider.set([PriceLeft, null]);
      }
      if (PriceRight && PriceRight != cur_verd[1]) {
        elem.noUiSlider.set([null, PriceRight]);
      }
    },
    'filters.verd': function () {
      const elem = this.elem;
      const val = this.filters[this.name];


      let cur_verd = elem.noUiSlider.get();
      let PriceLeft = parseInt(val[0]);
      let PriceRight = parseInt(val[1]);

      if (PriceLeft === 0) {
        elem.noUiSlider.set([0, null]);
      }
      if (PriceLeft && PriceLeft != cur_verd[0]) {
        elem.noUiSlider.set([PriceLeft, null]);
      }
      if (PriceRight && PriceRight != cur_verd[1]) {
        elem.noUiSlider.set([null, PriceRight]);
      }
    }*/
  }
};
</script>
